import Vue from 'vue';
import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';
import VTiptap from '@peepi/vuetify-tiptap';
import router from './router';
import store from './store/index';
import App from './App.vue';
import '@/assets/css/main.css';
import vuetify from './plugins/vuetify';

Vue.use(VTiptap);

Vue.config.productionTip = false;

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(VueRouter);
}

sync(store, router, { moduleName: 'route' });

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
